import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import {
  Row,
  Col,
  Button,
  Typography,
  Select,
  Input,
  Tabs,
  DatePicker,
  Divider,
  Card,
  Modal,
  Form,
  notification,
} from "antd";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";

import myDonationsActions from "../../redux/myDonations/actions";
import config from "../../Services/apiEndPoints";
import "../MyDonations/datePicker.css";
import { durationList, menuItems, donationsTypeList } from "./const";
import axiosInstance from "../../Services/axiosIntercepter";
import actions1 from "../../redux/donorDetails/actions";
import { isEmpty, isUndefined } from "lodash";

const { Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const MyDonations = () => {
  const [selectDuration, setSelectDuration] = useState("");
  const [selectedKey, setSelectedKey] = useState("1");
  const [form10B, setForm10B] = useState(false);
  const [selectedDonationType, setSelectedDonationType] = useState("all");
  const [selectedYear, setSelectedYear] = useState(null); // State for Financial Year
  const [dateRange, setDateRange] = useState("");
  const pan_number = localStorage.getItem("pannumber");

  const [searchParams, setSearchParams] = useState({
    from_date: "",
    to_date: "",
    last_month: "",
    last_year: "",
    last_three_months: "",
    transaction_id: "",
    last_six_months: "",
    current_year: "",
    current_month: "",
  });

  const dispatch = useDispatch();
  const { myDonationsList, YEAR, isFetching } = useSelector(
    (state) => state.myDonations
  );
  const donorId =
    localStorage.getItem("donorId") || sessionStorage.getItem("donor-Id");

  const handleDownload = async (donationId) => {
    try {
      // Use axiosInstance to make the GET request
      const response = await axiosInstance.get(
        `${config.downloadPDF}?donationId=${donationId}&donorId=${donorId}`
      );

      if (
        !response.data ||
        !response.data.data ||
        !response.data.data.base64Content
      ) {
        throw new Error("No base64Content found in response");
      }

      const base64Content = response.data.data.base64Content;
      const byteCharacters = atob(base64Content); // Decode the Base64 string to raw binary
      const byteArrays = [];

      // Convert the decoded string into byte array
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      // Create a Blob from the byte arrays
      const blob = new Blob(byteArrays, { type: "application/pdf" });

      // Create an object URL for the Blob
      const fileURL = window.URL.createObjectURL(blob);

      // Create an <a> element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = fileURL;

      // Optionally, set a file name for the downloaded file (you can make this dynamic if you prefer)
      link.download = "receipt_number.pdf"; // You can set the file name dynamically
      link.click();

      // Clean up the object URL
      window.URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const onChange = (key) => {
    setSelectedKey(key);
  };

  const getMyDonationsList = () => {
    dispatch(actions1.resetDonorPersonalDetails());
    dispatch(
      myDonationsActions.getMyDonationsList(
        `${config.myDonationsList}?donorId=${donorId}`
      )
    );
    dispatch(myDonationsActions.getYEAR(`${config.getyear}`));
  };

  useEffect(() => {
    getMyDonationsList();
  }, []);

  const downaload10BE = () => {
    if (isEmpty(pan_number) || isUndefined(pan_number)) {
      notification.error({
        description: "Please update your PAN card number to proceed.",
        placement: "topRight",
      });
      return;
    }
    // console.log(pan_number)
    setForm10B(true);
    // setPannumber(pan_number)
  };

  const submit10b = () => {
    let query = "";

    query += `pan_number=${pan_number}&`;
    if (selectedYear) {
      query += `financialYear=${selectedYear}`;
    } // Adjust this based on your API requirements

    if (selectedDonationType === "all") {
      // query += `donation_type=all` // Adjust this based on your API requirements
    } else if (selectedDonationType === "annadanam") {
      query += `donation_type=annadanam`;
    } else if (selectedDonationType === "festival") {
      query += `donation_type=festival`;
    }

    dispatch(myDonationsActions.downloadPDF(`${config.pdf10B}?${query}`));
    setForm10B(false);
    // setPannumber()
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const handleDonationTypeChange = (value) => {
    setSelectedDonationType(value);
  };

  const handlesearch = () => {
    let query = "";
    // Check for mobile number match

    if (donorId) {
      query += `donorId=${donorId}&`;
    }

    if (searchParams.transaction_id) {
      query += `transaction_id=${searchParams.transaction_id}&`;
    }

    // Add new duration conditions
    if (dateRange === "Last month") {
      query += `duration=last_month&`;
    } else if (dateRange === "Last year") {
      query += `duration=last_year`;
    } else if (dateRange === "Last three months") {
      query += `duration=last_three_months`;
    } else if (dateRange === "Last six months") {
      query += `duration=last_six_months`;
    } else if (dateRange === "Current year") {
      query += `duration=current_year`;
    } else if (dateRange === "Current month") {
      query += `duration=current_month`;
    } else if (dateRange === "Today") {
      query += `duration=today`;
    }

    if (dateRange === "Custom date") {
      if (searchParams?.from_date) {
        query += `from_date=${searchParams?.from_date}&`; // Use from_date from searchParams
      }
      if (searchParams.to_date) {
        query += `to_date=${searchParams?.to_date}`; // Use to_date from searchParams
      }
    }

    console.log(searchParams);

    // Reset action type and dispatch the action

    // dispatch(myDonationsActions.resetActionType())
    dispatch(
      myDonationsActions.getMyDonationsList(
        `${config.myDonationsList}?${query}`
      )
    );
  };

  const handleClear = () => {
    setSearchParams({
      from_date: "",
      to_date: "",
      last_month: "",
      last_year: "",
      last_three_months: "",
      transaction_id: "",
      last_six_months: "",
      current_year: "",
      current_month: "",
      transaction_id: "",
    });
    setDateRange("");

    getMyDonationsList();
  };

  const handleDateRangeChange = (selectedValue) => {
    setDateRange(selectedValue);

    // Clear custom dates if the user selects a predefined range
    if (selectedValue !== "Custom date") {
      setSearchParams({
        ...searchParams,
        from_date: "",
        to_date: "",
      });
    }
  };

  const handleDateChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      const fromDateParts = dateStrings[0].split("-");
      const toDateParts = dateStrings[1].split("-");
      const fromDateFormatted = `${fromDateParts[2]}/${fromDateParts[1]}/${fromDateParts[0]}`;
      const toDateFormatted = `${toDateParts[2]}/${toDateParts[1]}/${toDateParts[0]}`;
      // Update the search parameters with the new dates
      setSearchParams({
        ...searchParams,
        from_date: fromDateFormatted,
        to_date: toDateFormatted,
      });
    } else {
      // If no dates selected, clear the date fields
      setSearchParams({
        ...searchParams,
        from_date: "",
        to_date: "",
      });
    }
  };

  useEffect(() => {
    // Push the current state to history to prevent back navigation
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // This will force the user to stay on the current page
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const DonationItem = ({ item, type }) => {
    const fields = [
      { label: "Receipt No.", value: item?.receipt_no },
      { label: type === "annadanam" ? "Annadanam Date" : "Donation Date", value: type === "annadanam" ? dayjs(item?.annadanam_date).format("DD-MM-YYYY") : dayjs(item?.transaction_date).format("DD-MM-YYYY") },
      { label: "Donation Date", value: dayjs(item?.transaction_date).format("DD-MM-YYYY"), hide: type === "festival" },
      { label: "Transaction Id", value: item?.transaction_id },
      { label: "Donation Amount", value: item?.amount },
      { label: "Payment Type", value: type === "annadanam" ? item?.payment_type : item?.paymentType },
      { label: "Payment Method", value: item?.payment_method },
      { label: "Cheque Date", value: item?.cheque_date ? new Date(item.cheque_date).toLocaleDateString("en-GB") : "" },
      { label: "Cheque Number", value: item?.cheque_number },
      { label: "In favour of", value: item?.in_the_favor_of },
      { label: "Bank Name", value: item?.bank_name },
      { label: "Purpose", value: item?.notes },
      { label: "Cheque Status", value: item?.cheque_status },
      { label: "DD Date", value: item?.DD_date ? new Date(item.DD_date).toLocaleDateString("en-GB") : "" },
      { label: "DD Number", value: item?.DD_number },
    ].filter(f => f.value && !f.hide);

    return (
      <Col xs={24} style={{ marginBottom: "16px" }}>
        <div
          style={{
            position: "relative",
            padding: "16px",
            border: "1px solid #f0f0f0",
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            margin: "4px",
          }}
        >
          <Row gutter={[16, 12]}>
            {fields.map((field, idx) => (
              <Col xs={24} sm={12} md={8} key={idx}>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  gap: "8px"
                }}>
                  <Text strong style={{ fontSize: "13px", color: "#262626", flexShrink: 0 }}>
                    {field.label}:
                  </Text>
                  <Text style={{ fontSize: "14px", textAlign: "right", wordBreak: "break-word" }}>
                    {field.value}
                  </Text>
                </div>
              </Col>
            ))}
          </Row>
          <div style={{ marginTop: "16px", display: "flex", justifyContent: "flex-end", borderTop: "1px solid #f0f0f0", paddingTop: "12px" }}>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => handleDownload(item?._id)}
              style={{ backgroundColor: "rgba(255, 165, 0, 0.8)", borderRadius: "6px" }}
            >
              Receipt
            </Button>
          </div>
        </div>
      </Col>
    );
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column", // Stack elements vertically on small screens
          gap: "8px", // Space between elements
          marginRight: "20px",
          marginLeft: "25px",
          marginTop: "20px",
        }}
      >
        <Row gutter={[16, 16]} justify="center" align="middle">
          <Col xs={24} sm={8} md={6}>
            <Input
              value={searchParams.transaction_id}
              placeholder="Transaction ID"
              onChange={(e) =>
                setSearchParams({
                  ...searchParams,
                  transaction_id: e.target.value,
                })
              }
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={8} md={6}>
            <Select
              showSearch
              placeholder="Select Duration"
              optionFilterProp="label"
              value={dateRange || undefined}
              onSelect={handleDateRangeChange}
              style={{ width: "100%" }}
            >
              {durationList.map((item, index) => (
                <Option key={index} value={item.label} label={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Col>

          {dateRange === "Custom date" && (
            <Col xs={24} sm={24} md={12}>
              <RangePicker
                dropdownClassName="custom-datepicker"
                style={{ width: "100%" }}
                onChange={handleDateChange}
              />
            </Col>
          )}

          <Col xs={24} sm={12} md={6}>
            <div style={{ display: "flex", gap: "8px" }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                style={{
                  flex: 1,
                  backgroundColor: "rgba(255, 165, 0, 0.8)",
                }}
                onClick={() => {
                  handlesearch();
                }}
              >
                Search
              </Button>
              <Button
                type="primary"
                style={{
                  width: "80px",
                  backgroundColor: "rgba(255, 165, 0, 0.8)",
                }}
                onClick={() => handleClear()}
              >
                Clear
              </Button>
            </div>
          </Col>

          <Col xs={24} sm={4} md={2}>
            <Button
              color="success"
              size="sm"
              type="primary"
              style={{
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                width: "100%",
                backgroundColor: "rgba(255, 165, 0, 0.8)",
              }}
              onClick={() => downaload10BE()}
              icon={<DownloadOutlined />}
            >
              <span style={{ color: "white" }}>10BE</span>
            </Button>
          </Col>
        </Row>
      </div>

      {isFetching ? (
        <Spin
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <Card style={{ margin: 20 }}>
          <Tabs
            defaultActiveKey={selectedKey}
            items={menuItems}
            onChange={onChange}
          />
          {selectedKey === "1"
            ? myDonationsList?.Annadanam?.donations?.map((item) => (
              <DonationItem key={item._id} item={item} type="annadanam" />
            ))
            : null}

          {selectedKey === "2" ? (
            <Row gutter={16}>
              {myDonationsList?.Festival?.donations?.map((item) => (
                <DonationItem key={item._id} item={item} type="festival" />
              ))}
            </Row>
          ) : null}
        </Card>
      )}

      <Modal
        title="Confirm Action"
        open={form10B}
        onCancel={() => setForm10B(false)}
        maskClosable={false}
        footer={[
          <div
            key="footer"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              key="cancel"
              onClick={() => setForm10B(false)}
              style={{ width: "40%" }}
            >
              Cancel
            </Button>
            <Button
              key="download"
              type="primary"
              onClick={submit10b}
              style={{ width: "40%" }}
            >
              Download
            </Button>
          </div>,
        ]}
      >
        <Form layout="vertical">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Financial Year">
                <Select
                  placeholder="Select Year"
                  style={{ width: 140 }}
                  value={selectedYear}
                  onChange={handleYearChange}
                >
                  <Select.Option value="" disabled>
                    select year
                  </Select.Option>
                  {YEAR?.map((item) => (
                    <Select.Option key={item._id} value={item.year}>
                      {item.year}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Donation Type">
                <Select
                  value={selectedDonationType}
                  onChange={handleDonationTypeChange}
                  style={{ width: 140 }}
                >
                  <Select.Option value="all">All</Select.Option>
                  <Select.Option value="annadanam">Annadanam</Select.Option>
                  <Select.Option value="festival">Festival</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default MyDonations;
